import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { media } from 'styles/media'
import { countries } from '../content'
import DropdownMenu from './DropdownMenu'

const Container = styled.nav`
  margin-top: 0;
  margin-bottom: 36px;

  ${media.md`
    display: flex;
    flex-wrap: wrap;
    margin-top: 74px;
    margin-bottom: 64px;

    > ul {
      width: 35%;
      padding: 0;
    }
  `}

  ${media.lg`
    margin-top: 0;
    margin-bottom: 0;
  `}
`

const SubContainer = styled.div`
  width: 100%;

  ${media.md`
    display: flex;
    flex-wrap: wrap;
    width: 65%;
  `}
`

const NavList = styled.ul`
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 300;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;
  padding: 0 0 8px 0;

  ${media.md`
    border-bottom: none;
    margin-bottom: 0;
    padding: 0;
    width: 50%;
    padding-left: 16px;
    padding-bottom: 64px;
  `}

  li {
    display: block;
    margin-bottom: 12px;
  }

  a,
  button {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme?.['-ds-neutral-300']?.value};
    }
  }
`

const NavListHeading = styled.li`
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

const FooterMenu = () => {
  const [t] = useTranslation()

  return (
    <Container>
      <NavList>
        <NavListHeading>Explore</NavListHeading>
        {countries.map((country) => (
          <li key={country.code}>
            <DropdownMenu
              name={country.name}
              url={country.url}
              dropDownItems={country.states}
            />
          </li>
        ))}
      </NavList>

      <SubContainer>
        <NavList>
          <NavListHeading>Company</NavListHeading>
          <li>
            <a href="/about">Our Story</a>
          </li>
          <li>
            <a href="/how-it-works">How Riparide Works</a>
          </li>
          <li>
            <a href="/stories-travellers">Riparide Stories</a>
          </li>
          <li>
            <a href="/jobs" rel="noopener noreferrer" target="_blank">
              Careers
            </a>
          </li>
        </NavList>

        <NavList>
          <NavListHeading>Community</NavListHeading>
          <li>
            <a href="/stories-storytellers">Become a Storyteller</a>
          </li>
          <li>
            <a href="/list-with-us">Become a Host</a>
          </li>
        </NavList>

        <NavList>
          <NavListHeading>Gifting</NavListHeading>
          <li>
            <a href="/vouchers">Gift Vouchers</a>
          </li>
          <li>
            <a
              href="https://pages.riparide.com/employee-vouchers"
              target="_blank"
              rel="noopener noreferrer"
            >
              Employee Vouchers
            </a>
          </li>
        </NavList>

        <NavList>
          <NavListHeading>Support</NavListHeading>
          <li>
            <a
              href="https://help.riparide.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('helpCenter.name')}
            </a>
          </li>
          <li>
            <a href="/contact-us">Contact Us</a>
          </li>
        </NavList>
      </SubContainer>
    </Container>
  )
}

export default FooterMenu
